import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ChannelSidebar = ({ channelData, onDonate }) => {
  const formatScheduleTime = (time) => {
    return time;
  };

  return (
    <div className="channel-sidebar space-y-6">
      <div className="sidebar-card bg-card rounded-lg border border-border p-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4 flex items-center gap-2">
          <Icon name="BarChart3" size={20} color="var(--color-primary)" />
          Статистика канала
        </h3>
        <div className="space-y-3">
          <div className="stat-item flex justify-between items-center">
            <span className="text-sm text-muted-foreground">Всего прослушиваний</span>
            <span className="text-sm font-mono font-semibold text-foreground">
              {channelData?.stats?.totalPlays?.toLocaleString('ru-RU')}
            </span>
          </div>
          <div className="stat-item flex justify-between items-center">
            <span className="text-sm text-muted-foreground">Средняя длительность</span>
            <span className="text-sm font-mono font-semibold text-foreground">
              {channelData?.stats?.avgDuration}
            </span>
          </div>
          <div className="stat-item flex justify-between items-center">
            <span className="text-sm text-muted-foreground">Рейтинг</span>
            <div className="flex items-center gap-1">
              <Icon name="Star" size={14} color="var(--color-warning)" />
              <span className="text-sm font-mono font-semibold text-foreground">
                {channelData?.stats?.rating}
              </span>
            </div>
          </div>
          <div className="stat-item flex justify-between items-center">
            <span className="text-sm text-muted-foreground">Активность</span>
            <span className="text-sm font-mono font-semibold text-foreground">
              {channelData?.stats?.activity}
            </span>
          </div>
        </div>
      </div>
      <div className="sidebar-card bg-card rounded-lg border border-border p-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4 flex items-center gap-2">
          <Icon name="Calendar" size={20} color="var(--color-primary)" />
          Расписание эфиров
        </h3>
        <div className="space-y-3">
          {channelData?.schedule?.map((item, index) => (
            <div key={index} className="schedule-item">
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Icon name="Radio" size={20} color="var(--color-primary)" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-heading font-medium text-foreground mb-1">
                    {item?.day}
                  </p>
                  <p className="text-xs font-mono text-muted-foreground">
                    {formatScheduleTime(item?.time)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="sidebar-card bg-card rounded-lg border border-border p-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4 flex items-center gap-2">
          <Icon name="Share2" size={20} color="var(--color-primary)" />
          Социальные сети
        </h3>
        <div className="flex flex-wrap gap-2">
          {channelData?.socialLinks?.map((link, index) => (
            <a
              key={index}
              href={link?.url}
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 rounded-lg bg-muted hover:bg-primary/10 transition-colors duration-200"
              aria-label={link?.platform}
            >
              <Icon name={link?.icon} size={20} color="var(--color-foreground)" />
            </a>
          ))}
        </div>
      </div>
      <div className="sidebar-card bg-gradient-to-br from-primary/10 to-accent/10 rounded-lg border border-primary/20 p-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-2 flex items-center gap-2">
          <Icon name="Heart" size={20} color="var(--color-primary)" />
          Поддержать канал
        </h3>
        <p className="text-sm text-muted-foreground mb-4">
          Помогите развивать аутентичный контент
        </p>
        <Button
          variant="default"
          fullWidth
          iconName="DollarSign"
          iconPosition="left"
          onClick={onDonate}
        >
          Поддержать
        </Button>
        <div className="mt-4 pt-4 border-t border-border">
          <p className="text-xs text-muted-foreground mb-2">Принимаем:</p>
          <div className="flex flex-wrap gap-2">
            <span className="px-2 py-1 rounded bg-background text-xs font-mono text-foreground">
              ₽ RUB
            </span>
            <span className="px-2 py-1 rounded bg-background text-xs font-mono text-foreground">
              BTC
            </span>
            <span className="px-2 py-1 rounded bg-background text-xs font-mono text-foreground">
              ETH
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChannelSidebar;